import type { Delta, Op } from 'quill';

export function getFirstLineFromDelta(delta: Delta): Delta | null {
  let foundLine: Delta | null = null;
  delta.eachLine((line) => {
    foundLine = line;
    return false;
  });
  return foundLine;
}

export const deltaOnlyContainWhitespace = (ops: Op[]) =>
  ops.every(({ insert }) => typeof insert === 'string' && !insert.trim());
